import { helper } from '@ember/component/helper';

export function formatCurrency(params, hash) {
  let amount = Number(params[0]);
  let negation = amount < 0 ? '-' : '';
  amount = Math.abs(amount);
  let currency = hash.currency || '';
  return `${negation}${currency}${amount.toFixed(2)}`;
}

export default helper(formatCurrency);
